import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { UserSwitchOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  settingsModulesList,
  SettingsSubModuleDefinition,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const SettingsMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case SettingsSubModuleDefinition.addUser:
        return (
          <Menu.Item
            key={MenuIndexes.USERS_ADD_USER}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/users/add-user">{el.title}</Link>
          </Menu.Item>
        );
      case SettingsSubModuleDefinition.usersList:
        return (
          <Menu.Item
            key={MenuIndexes.USERS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/users">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = settingsModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <SubMenu
      key={SubMenuIndexes.SETTINGS}
      icon={<UserSwitchOutlined />}
      title={title}
      onTitleClick={(e) => subMenuClick(e)}
    >
      {checkPermissions.map((module) => renderSubModules(module))}
    </SubMenu>
  );
};
